export default function () {

  function modalOpen() {
    $('.btn-wrapper a').on('click', function () {
      $('.subscribe-modal').addClass('open');
    })

    $('.js-closebtn').on('click', function () {
      $('.subscribe-modal').removeClass('open');

      jQuery('.js-error-span').parent('.input-outter').removeClass('error-msg');

      jQuery('#fname').val('');
      jQuery('#lname').val('');
      jQuery('#email').val('');


      jQuery('.form-wrapper').show();
      jQuery('.modal-title').text('Stay In Touch');
      jQuery('.success-msg').hide();
    });

    $('.js-error-span').on('click', function () {
      $(this).parents('.input-outter').removeClass('error-msg');
      $(this).prev().focus();
    });

    $('.subscribe-modal .input-outter input').focus(function () {
      $(this).parent().removeClass('error-msg');
    });
  }

  modalOpen();

  $('.subscribe-newsletter').on('click', function (e) {
    e.preventDefault();

    let fname = jQuery('#fname').val();
    let lname = jQuery('#lname').val();
    let email = jQuery('#email').val();
    let ajaxurl = cetx_js_var.ajaxurl;
    let error = false;

    let nonce = jQuery(this).attr('data-nonce');

    if (fname == '') {
      jQuery('.js-err-fname').parent('.input-outter').addClass('error-msg');
      error = true;
    }

    if (lname == '') {
      jQuery('.js-err-lname').parent('.input-outter').addClass('error-msg');
      error = true;
    }

    if (email == '') {
      jQuery('.js-err-email').parent('.input-outter').addClass('error-msg');
      error = true;
    } else if (!ValidateEmail(email)) {
      jQuery('.js-err-email').parent('.input-outter').addClass('error-msg');
      error = true;
    }

    let userData = {
      'fname': fname,
      'lname': lname,
      'email': email,
    }

    if (!error) {
      jQuery.ajax({
        type: "post",
        dataType: "json",
        url: ajaxurl,
        data: { action: 'mailchimp_subscribe', userData: userData, nonce: nonce },
        success: function (response) {
          if (response.type == 'success') {
            jQuery('.form-wrapper').hide().fadeOut('slow');
            jQuery('.modal-title').text('Subscription Confirmation');
            jQuery('.success-msg').show().fadeIn('slow');

            jQuery('#fname').val('');
            jQuery('#lname').val('');
            jQuery('#email').val('');
          } else {
            jQuery('.js-err-exception').css('display', 'block');
          }
        },
        error: function (xhr, ajaxOptions, thrownError) {
        }
      });
    }

  });

  function ValidateEmail(email) {
    let mailformat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
    if (email.match(mailformat)) {
      return true;
    }
    else {
      return false;
    }
  }
}
